import React from 'react';
import Container from 'common/src/components/UI/Container';
import ParticlesComponent from '../../Hosting/Particle';
import BannerWrapper from './banner.style';

const BannerSection = () => {
  return (
    <BannerWrapper id="banner_section">
      <ParticlesComponent />
      <Container className="banner_container">
        <div className="content">
          <h1 className="title">Transparent, Contractless Pricing</h1>

          <div className="desc">
            Explore Pricing Options That Scale With You.
          </div>

          <div className="subtitle">
            Sign up for a FREE service. Credit card not required
          </div>
        </div>
      </Container>
    </BannerWrapper>
  );
};

export default BannerSection;
